export default {"src":"/_next/static/media/integration-ux-ui-data.a023cb26.svg","height":347,"width":414,"blurWidth":0,"blurHeight":0};